<template>
  <div class="period-college-container">
    <!-- Loading State -->
    <v-fade-transition>
      <div v-if="loading" class="text-center py-12">
        <v-progress-circular
          indeterminate
          color="primary"
          :width="4"
          :size="60"
        />
        <p class="mt-4 text-body1">กำลังโหลดข้อมูล...</p>
      </div>

      <!-- Main Content -->
      <div v-else>
        <!-- Info Header Card -->
        <v-card class="elevation-2 mb-6" style="border-radius: 12px">
          <v-card-text class="pa-6">
            <v-row align="center">
              <v-col cols="auto">
                <div class="edit-button">
                  <v-btn
                    fab
                    small
                    color="warning"
                    @click="period_collegeEdit()"
                    elevation="4"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </v-col>
              <v-col>
                <h3 class="font-weight-bold mb-0">
                  <v-icon small class="mr-2">mdi-calendar-check</v-icon>
                  ข้อมูลกำหนดการปฏิทิน
                </h3>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Info Grid -->
        <v-row class="mb-6">
          <!-- Period Info -->
          <v-col cols="12" md="6">
            <v-card
              class="info-card elevation-1"
              style="border-radius: 12px; border-left: 4px solid #FF9800"
            >
              <v-card-text class="pa-6">
                <div class="d-flex justify-space-between align-center mb-4">
                  <span class="font-weight-bold text-grey">ครั้งที่</span>
                  <v-chip color="warning" text-color="white" label small>
                    {{ period_colleges.period_college_times }}
                  </v-chip>
                </div>
                <div class="d-flex justify-space-between align-center mb-4">
                  <span class="font-weight-bold text-grey">ปีงบประมาณ</span>
                  <span class="font-weight-bold text-warning">
                    {{ period_colleges.period_college_year }}
                  </span>
                </div>
                <div class="d-flex justify-space-between align-center">
                  <span class="font-weight-bold text-grey">จำนวนงวด</span>
                  <v-chip color="info" text-color="white" label small>
                    {{ reporting_periods.length }} งวด
                  </v-chip>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- Date Range Info -->
          <v-col cols="12" md="6">
            <v-card
              class="info-card elevation-1"
              style="border-radius: 12px; border-left: 4px solid #2196F3"
            >
              <v-card-text class="pa-6">
                <div class="mb-4">
                  <p class="font-weight-bold text-grey mb-1">
                    <v-icon x-small class="mr-1">mdi-calendar-start</v-icon>
                    เริ่มวันที่
                  </p>
                  <p class="text-body2 font-weight-bold text-primary">
                    {{
                      period_colleges.period_college_start
                        | moment("add", "543 years")
                        | moment("D MMMM YYYY")
                    }}
                  </p>
                </div>
                <div>
                  <p class="font-weight-bold text-grey mb-1">
                    <v-icon x-small class="mr-1">mdi-calendar-end</v-icon>
                    สิ้นสุดวันที่
                  </p>
                  <p class="text-body2 font-weight-bold text-primary">
                    {{
                      period_colleges.period_college_stop
                        | moment("add", "543 years")
                        | moment("D MMMM YYYY")
                    }}
                  </p>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- File Upload Deadline -->
          <v-col cols="12" md="6">
            <v-card
              class="info-card elevation-1"
              style="border-radius: 12px; border-left: 4px solid #4CAF50"
            >
              <v-card-text class="pa-6">
                <p class="font-weight-bold text-grey mb-2">
                  <v-icon x-small class="mr-1">mdi-file-upload</v-icon>
                  วันที่สิ้นสุดแนบไฟล์
                </p>
                <p class="font-weight-bold text-success">
                  {{
                    period_colleges.period_college_attactmentstop
                      | moment("add", "543 years")
                      | moment("D MMMM YYYY")
                  }}
                </p>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- System Status -->
          <v-col cols="12" md="6">
            <v-card
              class="info-card elevation-1"
              style="border-radius: 12px; border-left: 4px solid #9C27B0"
            >
              <v-card-text class="pa-6">
                <v-row no-gutters class="align-center">
                  <v-col>
                    <p class="font-weight-bold text-grey mb-2">
                      <v-icon x-small class="mr-1">mdi-server-network</v-icon>
                      สถานะระบบ
                    </p>
                    <v-chip
                      :color="
                        period_colleges.period_college_enable === '1' || period_colleges.period_college_enable === 1
                          ? 'success'
                          : 'error'
                      "
                      text-color="white"
                      label
                      small
                      class="mb-2"
                    >
                      <v-icon small class="mr-1">
                        {{
                          period_colleges.period_college_enable === "1" || period_colleges.period_college_enable === 1
                            ? "mdi-check-circle"
                            : "mdi-close-circle"
                        }}
                      </v-icon>
                      {{
                        period_colleges.period_college_enable === "1" || period_colleges.period_college_enable === 1
                          ? "เปิด"
                          : "ปิด"
                      }}
                    </v-chip>
                  </v-col>
                  <v-col>
                    <p class="font-weight-bold text-grey mb-2">
                      <v-icon x-small class="mr-1">mdi-file</v-icon>
                      สถานะแนบไฟล์
                    </p>
                    <v-chip
                      :color="
                        period_colleges.period_college_enable_file === '1' || period_colleges.period_college_enable_file === 1
                          ? 'success'
                          : 'error'
                      "
                      text-color="white"
                      label
                      small
                    >
                      <v-icon small class="mr-1">
                        {{
                          period_colleges.period_college_enable_file === "1" || period_colleges.period_college_enable_file === 1
                            ? "mdi-check-circle"
                            : "mdi-close-circle"
                        }}
                      </v-icon>
                      {{
                        period_colleges.period_college_enable_file === "1" || period_colleges.period_college_enable_file === 1
                          ? "เปิด"
                          : "ปิด"
                      }}
                    </v-chip>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- ===== ส่วนแสดงงวดการรายงาน (ใหม่) ===== -->
        <v-card class="elevation-2 mb-6" style="border-radius: 12px">
          <v-card-title class="pb-2">
            <v-icon small class="mr-2" color="primary"
              >mdi-calendar-multiple</v-icon
            >
            งวดการรายงาน
            <v-spacer />
            <v-chip color="primary" text-color="white" small label>
              {{ reporting_periods.length }} / 12 งวด
            </v-chip>
          </v-card-title>
          <v-divider />
          <v-card-text class="pa-4">
            <div v-if="reporting_periods.length === 0" class="text-center py-8">
              <v-icon size="64" color="grey lighten-2"
                >mdi-calendar-blank</v-icon
              >
              <p class="text-body1 text-grey mt-4">
                ยังไม่มีงวดการรายงาน กรุณากดปุ่มแก้ไขเพื่อเพิ่มงวด
              </p>
            </div>

            <v-row v-else>
              <v-col
                v-for="(rp, idx) in reporting_periods"
                :key="rp.pcr_id || idx"
                cols="12"
                sm="6"
                md="4"
                lg="3"
              >
                <v-card
                  class="reporting-period-card elevation-1"
                  :style="{
                    borderRadius: '10px',
                    borderTop: `3px solid ${getColorForPeriod(rp.pcr_no)}`
                  }"
                >
                  <v-card-text class="pa-4">
                    <div class="d-flex justify-space-between align-center mb-3">
                      <v-chip
                        :color="getColorForPeriod(rp.pcr_no)"
                        text-color="white"
                        small
                        label
                      >
                        งวดที่ {{ rp.pcr_no }}
                      </v-chip>
                      <v-chip
                        :color="rp.pcr_enable === '1' || rp.pcr_enable === 1 ? 'success' : 'grey'"
                        text-color="white"
                        x-small
                        label
                      >
                        {{ rp.pcr_enable === "1" || rp.pcr_enable === 1 ? "เปิด" : "ปิด" }}
                      </v-chip>
                    </div>

                    <p class="text-caption font-weight-bold text-grey mb-1">
                      เดือนที่รายงาน
                    </p>
                    <div class="mb-3">
                      <v-chip
                        v-for="m in parseMonths(rp.pcr_months)"
                        :key="m"
                        x-small
                        class="mr-1 mb-1"
                        :color="getColorForPeriod(rp.pcr_no)"
                        outlined
                      >
                        {{ monthNames[m - 1] }}
                      </v-chip>
                    </div>

                    <div v-if="rp.pcr_start" class="text-caption">
                      <v-icon x-small class="mr-1">mdi-calendar-range</v-icon>
                      {{
                        rp.pcr_start
                          | moment("add", "543 years")
                          | moment("D MMM YY")
                      }}
                      -
                      {{
                        rp.pcr_stop
                          | moment("add", "543 years")
                          | moment("D MMM YY")
                      }}
                    </div>

                    <p
                      v-if="rp.pcr_comment"
                      class="text-caption text-grey mt-2 mb-0"
                    >
                      {{ rp.pcr_comment }}
                    </p>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Status Timeline -->
        <v-card class="elevation-1" style="border-radius: 12px">
          <v-card-title class="pb-4">
            <v-icon small class="mr-2">mdi-timeline</v-icon>
            ลำดับเวลาสำคัญ
          </v-card-title>
          <v-divider />
          <v-card-text class="pa-6">
            <v-timeline align-top>
              <v-timeline-item
                :icon="
                  `mdi-numeric-${period_colleges.period_college_times}-circle`
                "
                color="warning"
                large
              >
                <div class="mb-2">
                  <h4 class="font-weight-bold">
                    ครั้งที่ {{ period_colleges.period_college_times }} ปี
                    {{ period_colleges.period_college_year }}
                  </h4>
                  <p class="text-grey">เป็นช่วงการศึกษา</p>
                </div>
              </v-timeline-item>

              <v-timeline-item icon="mdi-calendar-start" color="info" large>
                <div class="mb-2">
                  <h4 class="font-weight-bold">เริ่มต้นการรายงาน</h4>
                  <p class="text-body2 font-weight-bold">
                    {{
                      period_colleges.period_college_start
                        | moment("add", "543 years")
                        | moment("D MMMM YYYY")
                    }}
                  </p>
                  <p class="text-grey">วันเริ่มต้นการรายงานข้อมูล</p>
                </div>
              </v-timeline-item>

              <v-timeline-item icon="mdi-calendar-end" color="primary" large>
                <div class="mb-2">
                  <h4 class="font-weight-bold">ปิดการรายงาน</h4>
                  <p class="text-body2 font-weight-bold">
                    {{
                      period_colleges.period_college_stop
                        | moment("add", "543 years")
                        | moment("D MMMM YYYY")
                    }}
                  </p>
                  <p class="text-grey">วันสิ้นสุดการรายงานข้อมูล</p>
                </div>
              </v-timeline-item>

              <v-timeline-item icon="mdi-file-upload" color="success" large>
                <div class="mb-2">
                  <h4 class="font-weight-bold">ปิดการแนบไฟล์</h4>
                  <p class="text-body2 font-weight-bold">
                    {{
                      period_colleges.period_college_attactmentstop
                        | moment("add", "543 years")
                        | moment("D MMMM YYYY")
                    }}
                  </p>
                  <p class="text-grey">วันสิ้นสุดการแนบไฟล์อักษรรับรอง</p>
                </div>
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
        </v-card>
      </div>
    </v-fade-transition>

    <!-- ===== Edit Dialog (ปรับใหม่รองรับหลายงวด) ===== -->
    <v-dialog
      v-model="editperiod_collegedialog"
      persistent
      max-width="1000px"
      scrollable
    >
      <v-card class="elevation-8" style="border-radius: 12px">
        <v-toolbar dark color="warning" rounded>
          <v-icon>mdi-pencil</v-icon>
          <v-toolbar-title class="ml-2">แก้ไขกำหนดการปฏิทิน</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="editperiod_collegedialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider />

        <v-card-text class="pa-6" style="max-height: 70vh; overflow-y: auto">
          <v-form ref="editperiod_collegeform" lazy-validation>
            <!-- ข้อมูลหลัก -->
            <h4 class="font-weight-bold mb-4">
              <v-icon small class="mr-1">mdi-information</v-icon>
              ข้อมูลหลัก
            </h4>
            <v-row>
              <v-col cols="12" md="4">
                <v-select
                  v-model="editperiod_college.period_college_year"
                  :items="period_collegeselect"
                  item-text="text"
                  item-value="value"
                  label="ปีงบประมาณ"
                  outlined
                  rounded
                  dense
                  prepend-icon="mdi-calendar"
                  :rules="[v => !!v || 'ต้องระบุปีงบประมาณ']"
                />
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model.number="editperiod_college.period_college_times"
                  type="number"
                  label="ครั้งที่"
                  outlined
                  rounded
                  dense
                  prepend-icon="mdi-counter"
                  min="1"
                  max="3"
                  :rules="[
                    v => !!v || 'ต้องระบุครั้งที่',
                    v => (v >= 1 && v <= 3) || 'ครั้งที่ต้องอยู่ระหว่าง 1-3'
                  ]"
                />
              </v-col>

              <v-col cols="12" md="4">
                <!-- ว่างไว้สำหรับ layout -->
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="editperiod_college.period_college_start"
                  type="date"
                  label="วันที่เริ่ม"
                  outlined
                  rounded
                  dense
                  prepend-icon="mdi-calendar-start"
                  :rules="[v => !!v || 'ต้องระบุวันที่เริ่ม']"
                />
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="editperiod_college.period_college_stop"
                  type="date"
                  label="วันที่สิ้นสุด"
                  outlined
                  rounded
                  dense
                  prepend-icon="mdi-calendar-end"
                  :rules="[v => !!v || 'ต้องระบุวันที่สิ้นสุด']"
                />
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="editperiod_college.period_college_attactmentstop"
                  type="date"
                  label="สิ้นสุดแนบไฟล์"
                  outlined
                  rounded
                  dense
                  prepend-icon="mdi-file-upload"
                  :rules="[v => !!v || 'ต้องระบุวันที่สิ้นสุดแนบไฟล์']"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-switch
                  v-model="editperiod_college.period_college_enable_sw"
                  label="เปิดใช้งานรายงาน"
                  class="mt-0"
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-switch
                  v-model="editperiod_college.period_college_enable_file_sw"
                  label="เปิดใช้งานแนบไฟล์"
                  class="mt-0"
                />
              </v-col>
            </v-row>

            <v-divider class="my-6" />

            <!-- ===== ส่วนจัดการงวดการรายงาน ===== -->
            <div class="d-flex align-center mb-4">
              <h4 class="font-weight-bold mb-0">
                <v-icon small class="mr-1">mdi-calendar-multiple</v-icon>
                งวดการรายงาน
              </h4>
              <v-spacer />
              <v-chip small color="info" text-color="white" class="mr-3">
                {{ edit_periods.length }} / 12 งวด
              </v-chip>
              <v-btn
                small
                color="success"
                rounded
                :disabled="edit_periods.length >= 12"
                @click="addPeriod()"
              >
                <v-icon small class="mr-1">mdi-plus</v-icon>
                เพิ่มงวด
              </v-btn>
            </div>

            <v-alert
              v-if="edit_periods.length === 0"
              type="warning"
              outlined
              dense
              rounded
              class="mb-4"
            >
              ยังไม่มีงวดการรายงาน กดปุ่ม "เพิ่มงวด" เพื่อเริ่มกำหนดงวด
            </v-alert>

            <!-- รายการงวด -->
            <v-card
              v-for="(period, pIdx) in edit_periods"
              :key="pIdx"
              class="mb-4 elevation-1"
              :style="{
                borderRadius: '10px',
                borderLeft: `4px solid ${getColorForPeriod(period.pcr_no)}`
              }"
            >
              <v-card-text class="pa-4">
                <v-row align="center">
                  <!-- หัวงวด -->
                  <v-col cols="12">
                    <div class="d-flex align-center mb-2">
                      <v-chip
                        :color="getColorForPeriod(period.pcr_no)"
                        text-color="white"
                        small
                        label
                        class="mr-3"
                      >
                        งวดที่ {{ period.pcr_no }}
                      </v-chip>
                      <v-spacer />
                      <v-switch
                        v-model="period.pcr_enable_sw"
                        label="เปิดงวดนี้"
                        dense
                        hide-details
                        class="mt-0 mr-4"
                      />
                      <v-btn
                        icon
                        small
                        color="error"
                        @click="removePeriod(pIdx)"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-col>

                  <!-- เลือกเดือน -->
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="period.selected_months"
                      :items="monthOptions"
                      item-text="text"
                      item-value="value"
                      label="เดือนที่รายงาน"
                      multiple
                      chips
                      small-chips
                      deletable-chips
                      outlined
                      dense
                      prepend-icon="mdi-calendar-month"
                      :rules="[
                        v =>
                          (v && v.length > 0) ||
                          'ต้องเลือกเดือนอย่างน้อย 1 เดือน'
                      ]"
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip
                          v-if="index < 4"
                          small
                          :color="getColorForPeriod(period.pcr_no)"
                          outlined
                          close
                          @click:close="removeMonth(period, item.value)"
                        >
                          {{ item.text }}
                        </v-chip>
                        <span
                          v-if="index === 4"
                          class="text-caption text-grey ml-1"
                        >
                          (+{{ period.selected_months.length - 4 }} เดือน)
                        </span>
                      </template>
                    </v-select>
                  </v-col>

                  <!-- หมายเหตุ -->
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="period.pcr_comment"
                      label="หมายเหตุ (ไม่บังคับ)"
                      outlined
                      dense
                      prepend-icon="mdi-note-text"
                      hide-details
                    />
                  </v-col>

                  <!-- วันที่เปิด-ปิดรายงานของงวดนี้ (ไม่บังคับ) -->
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="period.pcr_start"
                      type="date"
                      label="วันที่เปิดรายงานงวดนี้ (ไม่บังคับ)"
                      outlined
                      dense
                      prepend-icon="mdi-calendar-start"
                      hide-details
                      clearable
                    />
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="period.pcr_stop"
                      type="date"
                      label="วันที่ปิดรายงานงวดนี้ (ไม่บังคับ)"
                      outlined
                      dense
                      prepend-icon="mdi-calendar-end"
                      hide-details
                      clearable
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <!-- ปุ่มเพิ่มงวดด่วน -->
            <div
              v-if="edit_periods.length > 0 && edit_periods.length < 12"
              class="text-center mt-2 mb-4"
            >
              <v-btn text small color="primary" @click="addPeriod()">
                <v-icon small class="mr-1">mdi-plus-circle-outline</v-icon>
                เพิ่มงวดถัดไป
              </v-btn>
            </div>

            <!-- สรุปเดือนที่ใช้/ซ้ำ -->
            <v-alert
              v-if="duplicateMonthsWarning"
              type="warning"
              outlined
              dense
              rounded
              class="mt-2 mb-0"
            >
              <strong>คำเตือน:</strong> {{ duplicateMonthsWarning }}
            </v-alert>

            <v-alert type="info" outlined rounded class="mt-6 mb-0" dense>
              <strong>หมายเหตุ:</strong>
              หลังจากบันทึกการเปลี่ยนแปลง ระบบจะส่งการแจ้งเตือนไปยัง Line Notify
              ของสถานศึกษา
            </v-alert>
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-6">
          <v-spacer />
          <v-btn
            color="default"
            outlined
            rounded
            @click="editperiod_collegedialog = false"
          >
            <v-icon small class="mr-1">mdi-close</v-icon>
            ยกเลิก
          </v-btn>
          <v-btn
            color="warning"
            rounded
            @click="editperiod_collegeSubmit()"
            :loading="isSubmitting"
          >
            <v-icon small class="mr-1">mdi-check</v-icon>
            บันทึก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
      right
      rounded
    >
      <v-icon small class="mr-2">
        {{
          snackbar.color === "success" ? "mdi-check-circle" : "mdi-alert-circle"
        }}
      </v-icon>
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
import VueMoment from "vue-moment";
import moment from "moment-timezone";

export default {
  name: "PeriodCollegeGovernmentId",

  props: {
    period_college_id: {
      type: String
    }
  },

  data() {
    return {
      VueMoment,
      moment,
      loading: true,
      isSubmitting: false,
      ApiKey: "HRvec2021",
      valid: true,
      editperiod_collegedialog: false,
      snackbar: {
        show: false,
        color: "success",
        timeout: 4000,
        text: ""
      },
      period_colleges: {
        period_college_times: "",
        period_college_year: "",
        period_college_start: "",
        period_college_stop: "",
        period_college_attactmentstop: "",
        period_college_enable: "1",
        period_college_enable_file: "1"
      },
      editperiod_college: {},
      // งวดการรายงาน (จากตาราง period_college_reporting)
      reporting_periods: [],
      // งวดที่กำลังแก้ไขใน dialog
      edit_periods: [],
      period_collegeselect: [
        { value: "2564", text: "2564" },
        { value: "2565", text: "2565" },
        { value: "2566", text: "2566" },
        { value: "2567", text: "2567" },
        { value: "2568", text: "2568" },
        { value: "2569", text: "2569" },
        { value: "2570", text: "2570" }
      ],
      // ตัวเลือกเดือน
      monthOptions: [
        { value: 1, text: "ม.ค. (1)" },
        { value: 2, text: "ก.พ. (2)" },
        { value: 3, text: "มี.ค. (3)" },
        { value: 4, text: "เม.ย. (4)" },
        { value: 5, text: "พ.ค. (5)" },
        { value: 6, text: "มิ.ย. (6)" },
        { value: 7, text: "ก.ค. (7)" },
        { value: 8, text: "ส.ค. (8)" },
        { value: 9, text: "ก.ย. (9)" },
        { value: 10, text: "ต.ค. (10)" },
        { value: 11, text: "พ.ย. (11)" },
        { value: 12, text: "ธ.ค. (12)" }
      ],
      monthNames: [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค."
      ],
      // สีสำหรับแต่ละงวด
      periodColors: [
        "#1976D2",
        "#388E3C",
        "#F57C00",
        "#7B1FA2",
        "#C62828",
        "#00838F",
        "#4E342E",
        "#AD1457",
        "#283593",
        "#558B2F",
        "#EF6C00",
        "#6A1B9A"
      ],
      data_syslog: {},
      line_topic: ""
    };
  },

  computed: {
    date_today_log() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0");
      let yyyy = today.getFullYear() + 543;
      let time =
        String(today.getHours()).padStart(2, "0") +
        ":" +
        String(today.getMinutes()).padStart(2, "0") +
        ":" +
        String(today.getSeconds()).padStart(2, "0");
      return dd + "/" + mm + "/" + yyyy + " " + time;
    },

    // ตรวจสอบเดือนซ้ำระหว่างงวด
    duplicateMonthsWarning() {
      const allMonths = [];
      const duplicates = [];
      for (const p of this.edit_periods) {
        if (p.selected_months) {
          for (const m of p.selected_months) {
            if (allMonths.includes(m)) {
              const monthName = this.monthNames[m - 1];
              if (!duplicates.includes(monthName)) {
                duplicates.push(monthName);
              }
            }
            allMonths.push(m);
          }
        }
      }
      if (duplicates.length > 0) {
        return `เดือนที่ซ้ำกันระหว่างงวด: ${duplicates.join(", ")}`;
      }
      return null;
    }
  },

  async mounted() {
    await this.period_collegeQueryAll();
    await this.loadReportingPeriods();
  },

  methods: {
    parseMonths(monthStr) {
      if (!monthStr) return [];
      return monthStr
        .split(",")
        .map(m => parseInt(m.trim()))
        .filter(m => !isNaN(m))
        .sort((a, b) => a - b);
    },

    getColorForPeriod(pcrNo) {
      return this.periodColors[(pcrNo - 1) % this.periodColors.length];
    },

    removeMonth(period, monthValue) {
      const idx = period.selected_months.indexOf(monthValue);
      if (idx >= 0) {
        period.selected_months.splice(idx, 1);
      }
    },

    addPeriod() {
      if (this.edit_periods.length >= 12) return;
      const nextNo =
        this.edit_periods.length > 0
          ? Math.max(...this.edit_periods.map(p => p.pcr_no)) + 1
          : 1;
      this.edit_periods.push({
        pcr_no: nextNo,
        selected_months: [],
        pcr_start: "",
        pcr_stop: "",
        pcr_enable_sw: false,
        pcr_comment: ""
      });
    },

    removePeriod(idx) {
      this.edit_periods.splice(idx, 1);
      // Renumber
      this.edit_periods.forEach((p, i) => {
        p.pcr_no = i + 1;
      });
    },

    async period_collegeQueryAll() {
      try {
        this.loading = true;
        const result = await this.$http.post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_id: this.period_college_id
        });
        this.period_colleges = result.data || {};
      } catch (error) {
        console.error("Error loading period college:", error);
        this.showSnackbar("ไม่สามารถโหลดข้อมูลได้", "error");
      } finally {
        this.loading = false;
      }
    },

    async loadReportingPeriods() {
      try {
        const result = await this.$http.post("period_college_reporting.php", {
          ApiKey: this.ApiKey,
          action: "query",
          period_college_id: this.period_college_id
        });
        this.reporting_periods = Array.isArray(result.data) ? result.data : [];
      } catch (error) {
        console.error("Error loading reporting periods:", error);
        this.reporting_periods = [];
      }
    },

    async period_collegeEdit() {
      try {
        const result = await this.$http.post("period_college.php", {
          ApiKey: this.ApiKey,
          period_college_id: this.period_college_id
        });

        this.editperiod_college = JSON.parse(JSON.stringify(result.data));

        this.editperiod_college.period_college_enable_sw =
          this.editperiod_college.period_college_enable === "1";

        this.editperiod_college.period_college_enable_file_sw =
          this.editperiod_college.period_college_enable_file === "1";

        // โหลดงวดการรายงานสำหรับแก้ไข
        let data = {
          ApiKey: this.ApiKey,
          action: "query",
          period_college_id: this.period_college_id
        };
        const rpResult = await this.$http.post(
          "period_college_reporting.php",
          data
        );
        console.log("Reporting periods for edit:", rpResult.data);
        const rpData = Array.isArray(rpResult.data) ? rpResult.data : [];
        this.edit_periods = rpData.map(rp => ({
          pcr_id: rp.pcr_id,
          pcr_no: parseInt(rp.pcr_no),
          selected_months: this.parseMonths(rp.pcr_months),
          pcr_start: rp.pcr_start || "",
          pcr_stop: rp.pcr_stop || "",
          pcr_enable_sw: rp.pcr_enable === "1",
          pcr_comment: rp.pcr_comment || ""
        }));

        this.editperiod_collegedialog = true;
      } catch (error) {
        console.error("Error loading edit data:", error);
        this.showSnackbar("ไม่สามารถโหลดข้อมูลสำหรับแก้ไข", "error");
      }
    },

    async topics_data() {
      const topicMap = {
        teacher_request: "สถานศึกษารวบรวมคำร้องขอย้าย ตำแหน่งครู",
        movement_college: "สถานศึกษาแจ้งเงือนไขการย้าย",
        update_college: "รายงานอัตรากำลัง",
        discuss_college: "ขอความเห็นจากคณะกรรมการสถานศึกษาย้ายสายบริหาร",
        discuss_teacher: "ขอความเห็นจากคณะกรรมการสถานศึกษาย้าย ตำแหน่งครู",
        reportmove_teacher: "รายงานตัว การย้าย ตำแหน่งครู",
        report_govcollege_sa: "รายงานข้อมูลพนักงานราชการ"
      };
      return topicMap[this.editperiod_college.period_college_type] || "";
    },

    async linenotify(topics, details, datetime_close) {
      try {
        await this.$http.post("linenotify_college.php", {
          ApiKey: this.ApiKey,
          topics: topics,
          details: details,
          datetime_close: datetime_close
        });
      } catch (error) {
        console.error("Error sending line notification:", error);
      }
    },

    async editperiod_collegeSubmit() {
      if (!this.$refs.editperiod_collegeform.validate()) {
        this.showSnackbar("กรุณาตรวจสอบข้อมูลให้ครบถ้วน", "warning");
        return;
      }

      // ตรวจสอบงวดต้องมีเดือนที่เลือก
      for (const p of this.edit_periods) {
        if (!p.selected_months || p.selected_months.length === 0) {
          this.showSnackbar(
            `งวดที่ ${p.pcr_no} ต้องเลือกเดือนอย่างน้อย 1 เดือน`,
            "warning"
          );
          return;
        }
      }

      this.isSubmitting = true;

      try {
        // 1. บันทึกข้อมูลหลัก period_college
        if (this.editperiod_college.period_college_enable_sw === true) {
          this.editperiod_college.period_college_enable = "1";
          const timesy =
            this.editperiod_college.period_college_times +
            "/" +
            this.editperiod_college.period_college_year;
          const topic = await this.topics_data();
          await this.linenotify(
            timesy,
            topic,
            this.editperiod_college.period_college_stop
          );
        } else {
          this.editperiod_college.period_college_enable = "0";
        }

        this.editperiod_college.period_college_enable_file =
          this.editperiod_college.period_college_enable_file_sw === true
            ? "1"
            : "0";

        this.editperiod_college.ApiKey = this.ApiKey;

        const result = await this.$http.post(
          "period_college.update.php",
          this.editperiod_college
        );

        // 2. บันทึกงวดการรายงาน
        const periodsToSave = this.edit_periods.map(p => ({
          pcr_no: p.pcr_no,
          pcr_months: p.selected_months.sort((a, b) => a - b).join(","),
          pcr_start: p.pcr_start || null,
          pcr_stop: p.pcr_stop || null,
          pcr_enable: p.pcr_enable_sw ? "1" : "0",
          pcr_comment: p.pcr_comment || null
        }));

        let data = {
          ApiKey: this.ApiKey,
          action: "save_all",
          period_college_id: this.period_college_id,
          periods: periodsToSave
        };
        let result_save = await this.$http.post(
          "period_college_reporting.php",
          data
        );
        console.log("Save reporting periods result:", result_save.data);
        this.showSnackbar("บันทึกข้อมูลเรียบร้อย", "success");
        this.editperiod_collegedialog = false;

        // Update system log
        let userSession = JSON.parse(sessionStorage.getItem("user")) || {};
        this.data_syslog = {
          ApiKey: this.ApiKey,
          user_account: userSession.user_name || "Unknown",
          event_log: "update",
          page_log: "period_college",
          table_log: "period_college",
          date_times: this.date_today_log
        };

        await this.$http.post("data_syslog.insert.php", this.data_syslog);

        // Reload data
        await this.period_collegeQueryAll();
        await this.loadReportingPeriods();
      } catch (error) {
        console.error("Error submitting edit:", error);
        this.showSnackbar("เกิดข้อผิดพลาดในการบันทึก", "error");
      } finally {
        this.isSubmitting = false;
      }
    },

    showSnackbar(text, color = "success") {
      this.snackbar = {
        show: true,
        text: text,
        color: color,
        timeout: 4000
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.period-college-container {
  width: 100%;
}

.edit-button {
  display: flex;
  justify-content: center;
  align-items: center;

  ::v-deep .v-btn {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      transform: scale(1.1) rotate(5deg);
    }

    &:active {
      transform: scale(0.95);
    }
  }
}

.info-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1) !important;
  }
}

.reporting-period-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08) !important;
  }
}

::v-deep {
  .v-timeline {
    &::before {
      background: linear-gradient(
        to bottom,
        rgba(33, 150, 243, 0.3),
        rgba(76, 175, 80, 0.3)
      );
    }
  }

  .v-timeline-item {
    padding-top: 12px;
    padding-bottom: 12px;

    .v-timeline-item__dot {
      border: 3px solid white;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
  }
}
</style>
